export default {"src":"/_next/static/media/license.fd0ed2b1.svg","height":69,"width":214,"blurWidth":0,"blurHeight":0};